var module = angular.module('octopusApp.master');

module.directive('progressStep', [function () {
    return {
        templateUrl: 'areas/master/getting-started/views/progress_step.html',
        restrict: 'E',
        scope: {
            current: '=progression',
            enabled: '=',
            header: '@',
            imgSrc: '@'
        },
        link: function (scope, element) {
            if (scope.enabled === false) {
                angular.element(element.children()[0]).css('opacity', 0.4);
            }
        }
    };
}]);


//////////////////
// WEBPACK FOOTER
// ./app/areas/master/getting-started/directives/progress_step.js
// module id = 1243666678679442
// module chunks = 1